import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'

import RadioBlock from '../../../../../../../components/Form/RadioBlock'
import TikTokVideoUpload from './TikTokVideoUpload'
import TikTokVideoFilesLibrary from './TikTokVideoFilesLibrary'
import TikTokVideoThumbnailLibrary from './TikTokVideoThumbnailLibrary'
import ErrorMessage from '../../../../../../../components/Form/ErrorMessage'

import { clearTikTokVideoThumbnails } from '../../../../../../../modules/actions/tikTokConstants'

import { VIDEO_FROM_LIBRARY_OPTION, VIDEO_OPTION, VIDEO_UPLOAD_OPTION } from '../../fields'
import {
  FILE_ID,
  MEDIA_FILE_UPLOAD,
  MEDIA_FILE_VIDEO_USE_LIBRARY
} from '../../../../../../ReusableFormFields/AdFileUpload/fields'
import { MEDIA_TYPE } from '../../../../../../Google/AdForms/fields'

function VideoRadioButtons({ formik }) {
  const dispatch = useDispatch()

  const [previousVideoUrl, setPreviousVideoUrl] = useState('')

  const { setFieldValue, values, errors, touched } = formik

  const showSelectVideoError = errors[FILE_ID] && touched[FILE_ID]

  const thumbnailLibraryProps = useMemo(
    () => ({
      formik,
      previousVideoUrl,
      setPreviousVideoUrl
    }),
    [formik, previousVideoUrl]
  )

  const onVideoRemoveHandler = useCallback(() => {
    dispatch(clearTikTokVideoThumbnails())

    setPreviousVideoUrl('')
  }, [dispatch])

  useEffect(
    () => () => {
      dispatch(clearTikTokVideoThumbnails())
    },
    [dispatch]
  )

  return (
    <>
      <RadioBlock
        setFieldValue={setFieldValue}
        id="radio_tiktok_video_upload"
        name={VIDEO_OPTION}
        value={VIDEO_UPLOAD_OPTION}
        selectedValue={values[VIDEO_OPTION]}
        label="Upload a file from my device"
      >
        <TikTokVideoUpload formik={formik} onVideoRemoveHandler={onVideoRemoveHandler} />
        <TikTokVideoThumbnailLibrary
          allowShowingThumbnailsLibrary={values[MEDIA_TYPE] === MEDIA_FILE_UPLOAD}
          {...thumbnailLibraryProps}
        />
      </RadioBlock>
      <RadioBlock
        setFieldValue={setFieldValue}
        id="radio_tiktok_video_from_library"
        name={VIDEO_OPTION}
        value={VIDEO_FROM_LIBRARY_OPTION}
        selectedValue={values[VIDEO_OPTION]}
        label="Use an existing video from the library"
      >
        <TikTokVideoFilesLibrary formik={formik} onVideoRemoveHandler={onVideoRemoveHandler} />
        {showSelectVideoError && <ErrorMessage error={errors[FILE_ID]} />}
        <TikTokVideoThumbnailLibrary
          allowShowingThumbnailsLibrary={values[MEDIA_TYPE] === MEDIA_FILE_VIDEO_USE_LIBRARY}
          {...thumbnailLibraryProps}
        />
      </RadioBlock>
    </>
  )
}

export default VideoRadioButtons
